import { useState } from 'react';

export default function useAuthModel() {
  const [jumpRoute, setJumpRoute] = useState(null);

  return {
    jumpRoute,
    setJumpRoute,
  };
}
